<template>
    <animation>
        <div class="prologue">
            <div class="d-flex justify-center">
                <v-card flat tile class="title-card text-center" style="width: 80%; max-width: 800px;">
                    <span class="title-text">
                        現在から未来へ
                    </span>
                </v-card>
            </div>
            <div class="d-flex justify-center">
                <v-card flat class="passage">
                    &nbsp;&nbsp;このように本会が歩んできた道は、時代の流れとともに紆余曲折してきましたが、先人の取組みを振り返れば、その先駆性とエネルギーは敬服に値します。それ以上に、時代のニーズを読み取り、制度や前例あるいは従来の殻を超えた取組みも数多く見られます。<br/>
                    &nbsp;&nbsp;ご本人は親元での生活や入所生活から、様々な活動をし・働き・自立した生活へ。そしてそれを様々な形で支援していく。決して制度に追従するだけでなく、研究や工夫そして連携によって時には制度をはみ出し、あるいは新たに制度を生み出す原動力になってきました。障害者や支援者を含め社会の誰もが安全安心に、過ごしやすく働きやすく暮らしやすい環境を整えることが必要です。<br/>
                    &nbsp;&nbsp;福祉協会は知的障害者福祉という限られた分野の事業であっても、辿っていけば社会のあらゆるものと繋がっています。この一つが欠ければ、社会の歯車が外れかけてしまいます。何一つ排除しない、誰一人取り残さない。まさにSDGｓの理念と大きく重なるところです。<br/>
                    &nbsp;&nbsp;共生社会への壁は思いのほか高く、一朝一夕では実現できないことは歴史からも明らかです。社会全体が、あらゆる差別や偏見を排除し、様々な信条や国籍、障害の有無等々の多様性を認め、支え合っていくこと。<br/>
                    &nbsp;&nbsp;60年の時を経て、高齢化社会の到来、また感染症や温暖化による災害など多難な未来も予想される中、社会の柔らかな壁に包まれ障害があっても普通に楽しく暮らしていくためには何が必要なのか。利用者の暮らしと人権の擁護、障害者支援への誇りと自信獲得のための職員育成、そして事業所運営と連携のサポート、といった使命に向かって、様々なコンテンツを愛知から次々と発信していきたいと考えます。その意味で、福祉協会という宇宙船はこれからも新しい旅を続けていくことになるでしょう。
                </v-card>
            </div>
        </div>
    </animation>
</template>

<script>
import Animation from './Animation.vue'
export default {
    name: "Prologue",
    components: { 
        Animation 
    },
}
</script>

<style scoped>
.prologue {
    margin-bottom: 30px;
}
.title-card {
    margin: 30px 0;
}
.title-text {
    font-weight: bold;
    font-size: 35px;
    
    border-bottom: solid 3px #98494C;
}
.passage {
    width: 80%; 
    max-width: 800px;
}
</style>